import { Modal, Form, Space, Input, Button } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const FieldJoinModal = ({
  disabled,
  open,
  setOpen,
  joinForm,
  fieldPath,
  handleFieldMappingChange,
  onValuesChange,
}) => {
  return (
    <Modal
      centered
      title="JOIN 條件設定"
      width={800}
      open={open}
      okButtonProps={{ autoFocus: true, htmlType: "submit" }}
      onCancel={() => setOpen(false)}
      modalRender={(dom) => (
        <Form
          form={joinForm}
          disabled={disabled}
          layout="vertical"
          requiredMark={false}
          onValuesChange={onValuesChange}
          onFinish={(values) => {
            handleFieldMappingChange(
              fieldPath + ".source.joinConditions",
              values["joinConditions"] || []
            );
            setOpen(false);
          }}
        >
          {dom}
        </Form>
      )}
      styles={{
        body: {
          paddingTop: "20px",
          maxHeight: "80vh",
          overflowY: "auto",
        },
      }}
    >
      <Form.List name="joinConditions">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Space key={key}>
                <Form.Item
                  {...restField}
                  name={[name, "sourceTable"]}
                  label="來源資料表"
                  rules={[
                    { required: true, message: "請填寫 join 來源資料表名稱" },
                  ]}
                >
                  <Input placeholder="join 來源資料表名稱" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, "sourceColumn"]}
                  label="來源欄位"
                  rules={[
                    { required: true, message: "請填寫 join 來源欄位名稱" },
                  ]}
                >
                  <Input placeholder="join 來源欄位名稱" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, "targetTable"]}
                  label="目標資料表"
                  rules={[
                    { required: true, message: "請填寫 join 目標資料表名稱" },
                  ]}
                >
                  <Input placeholder="join 目標資料表名稱" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, "targetColumn"]}
                  label="目標欄位"
                  rules={[
                    { required: true, message: "請填寫 join 目標欄位名稱" },
                  ]}
                >
                  <Input placeholder="join 目標欄位名稱" />
                </Form.Item>
                <MinusCircleOutlined
                  onClick={() => remove(name)}
                  style={{ color: "red" }}
                />
              </Space>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                新增 JOIN 條件
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Modal>
  );
};

export default FieldJoinModal;
